export enum CBTProgramWeekOneStep {
    WhatIsEmotionalDistressStep = 'what-is-emotional-distress',
    EmotionalDistress = 'emotional-distress',
    LearningAboutEmotionalDistressStep = 'learning-about-emotional-distress',
    WhatDoesThisLookLikeStep = 'what-does-this-look-like',
    StrongEmotionsStep = 'strong-emotions',
    NotWantingEmotionsStep = 'not-wanting-emotions',
    AvoidanceStep = 'avoidance',
    WhatsNextStep = 'whats-next',
}

export enum CBTProgramWeekOneSurvey {
    EmotionalDistress = 'week-1-emotional-distress',
    StrongEmotions = 'week-1-strong-emotions',
    NotWantingEmotions = 'week-1-not-wanting-emotions',
    Avoidance = 'week-1-avoidance',
}
